"use client";

import { FC } from "react";
import { usePathname, useRouter } from "apps/website/i18n/navigation";

import IconButton from "../../base/IconButton/IconButton";

const CUSTOMER_HOME_BACK_PATHS = new Set([
  "/customer/my-deliveries/delay/discount",
  "/customer/my-deliveries/delay/next-delivery",
]);

interface IBackButton {
  to?: string;
}

const BackButton: FC<IBackButton> = ({ to }) => {
  const router = useRouter();
  const pathname = usePathname();

  const destination = to ?? (
    CUSTOMER_HOME_BACK_PATHS.has(pathname)
      ? "/customer"
      : undefined
  );

  return (
    <IconButton
      icon="chevronLeft"
      to={ destination }
      onClick={ destination ? undefined : () => router.back() }
      label="Go back"
      size="xsmall"
      className="flex-row-reverse"
      textClassName="underline"
      textSize="xs"
      display="subtitle"
    >Back</IconButton>
  );
};

export default BackButton;
